import { render } from "./editCustomerDialog.vue?vue&type=template&id=2bc25434"
import script from "./editCustomerDialog.vue?vue&type=script&lang=js"
export * from "./editCustomerDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__